var _ref2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgTrash = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 16.978,
      height: 16.978,
      viewBox: "0 0 16.978 16.978",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("g", {
      id: "_004-trash-bin",
      "data-name": "004-trash-bin",
      transform: "translate(-2 -2)"
    },
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_19147",
      "data-name": "Path 19147",
      d: "M18.129,5H2.849a.849.849,0,1,0,0,1.7h1.7V16.884a2.547,2.547,0,0,0,2.547,2.547h6.791a2.547,2.547,0,0,0,2.547-2.547V6.7h1.7a.849.849,0,0,0,0-1.7ZM9.64,14.338a.849.849,0,1,1-1.7,0V10.093a.849.849,0,1,1,1.7,0Zm3.4,0a.849.849,0,1,1-1.7,0V10.093a.849.849,0,1,1,1.7,0Z",
      transform: "translate(0 -0.453)"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_19148",
      "data-name": "Path 19148",
      d: "M9.849,3.7h3.4a.849.849,0,1,0,0-1.7h-3.4a.849.849,0,1,0,0,1.7Z",
      transform: "translate(-1.058)"
    }))))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Trash.bb16759b.svg";
export { ForwardRef as ReactComponent };